// Curated editorial service imagery for marketing surfaces (homepage hero +
// category tiles). These are NOT fake business data — real businesses always
// render their own uploaded photos. Natural, on-the-job service shots only.

export const CATEGORY_IMAGES = {
  hair: "https://images.unsplash.com/photo-1647140655214-e4a2d914971f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "auto-repair": "https://images.unsplash.com/photo-1620584898989-d39f7f9ed1b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  cleaning: "https://images.unsplash.com/photo-1758523670739-0d26a3ee976d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  photography: "https://images.unsplash.com/photo-1542992933-ce75d0187ec1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  fitness: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "pet-grooming": "https://images.unsplash.com/photo-1791714887477-c71786e32fba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "home-repair": "https://images.unsplash.com/photo-1581783898377-1c85bf937427?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  tutoring: "https://images.unsplash.com/photo-1758685733907-42e9651721f5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "event-planning": "https://images.unsplash.com/photo-1502635385003-ee1e6a1a742d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  "private-chef": "https://images.unsplash.com/photo-1564844536308-50b114a1d946?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  other: "https://images.unsplash.com/photo-1503951914875-452162b0f3f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const categoryImage = (slug) => CATEGORY_IMAGES[slug] || CATEGORY_IMAGES.other;

// Hero collage — three moody, craft-focused shots.
export const HERO_COLLAGE = [
  { url: "https://images.unsplash.com/photo-1647140655214-e4a2d914971f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", label: "Barber & grooming" },
  { url: "https://images.unsplash.com/photo-1620584898989-d39f7f9ed1b7?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", label: "Auto detailing" },
  { url: "https://images.unsplash.com/photo-1542992933-ce75d0187ec1?crop=entropy&cs=srgb&fm=jpg&q=85&w=900", label: "Photography" },
];
